export enum ETipoPreferencia {
    Sistema = 1,
    Usuario = 2
}
